import { forwardRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { CardLayout } from '../../lib/card';
import { usePost } from '../Post';
import {
  CardActionsBlock,
  CardContainer,
  CardMediaBlock,
  CardPreviewLinkBlock,
  CardRepostPreviewBlock,
  CardTextBlock,
  CardUserBlock
} from '../parts';
import { usePostAction, usePostSettings } from '../utils';

interface Card3Props {
  space: number;
}

export const Card3 = forwardRef<HTMLDivElement, Card3Props>(
  ({ space, ...forwardingProps }, forwardingRef) => {
    const { showMedia, showTextLink } = usePost();
    const { backgroundColor, borderRadius, overlayColor, showShadow, shadow } =
      usePostSettings();
    const handleAction = usePostAction();

    const [isDropDownOpen, setIsDropDownOpen] = useState(false);

    return (
      <CardContainer
        {...forwardingProps}
        ref={forwardingRef}
        onClick={handleAction}
        _overlay
        _space={space}
        _backgroundColor={showMedia ? undefined : backgroundColor}
        _borderRadius={borderRadius}
        _minHeight={180}
        _shadow={showShadow ? shadow : undefined}
      >
        {showMedia ? (
          <>
            <CardMediaBlock thumbnail _grow />

            <ContentLayer
              _withAnimation
              _overlayColor={overlayColor}
              _isOverlayShown={isDropDownOpen}
            >
              <CardTextBlock disableControl />
              <CardUserBlock withSource />
              <CardActionsBlock
                withTopDivider
                setIsDropDownOpen={setIsDropDownOpen}
              />
            </ContentLayer>
          </>
        ) : (
          <>
            <CardTextBlock grow />
            <CardRepostPreviewBlock />
            {showTextLink && <CardPreviewLinkBlock />}
            <CardUserBlock withSource />
            <CardActionsBlock
              withTopDivider
              setIsDropDownOpen={setIsDropDownOpen}
            />
          </>
        )}
      </CardContainer>
    );
  }
);

Card3.displayName = 'Card3';

const ContentLayer = styled(CardLayout.HiddenLayer)<{
  _overlayColor?: string;
}>`
  height: auto;
  justify-content: flex-end;
  top: initial;
  padding-top: 60px !important;

  ${({ _overlayColor }) =>
    !!_overlayColor &&
    css`
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        ${_overlayColor} 34%,
        ${_overlayColor} 100%
      );
    `};
`;
